import React, { useState, useEffect } from "react";
import {
  Form,
  Button,
  Badge,
  CloseButton,
  InputGroup,
  Card,
  Row,
  Col,
} from "react-bootstrap";

import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getTaskNumberById, updateTaskNumber } from "../../../../services/TaskNumberService";

const EditTaskNumber = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fullName: "",
    employeeId: "",
    taskNumbers: [],
    id: "",
  });
  const [currentTaskNumber, setCurrentTaskNumber] = useState("");

  useEffect(() => {
    const fetchTaskNumber = async () => {
      try {
        const taskNumberData = await getTaskNumberById(id);
        setFormData({fullName: taskNumberData.fullName,
          employeeId: taskNumberData.employeeId,
          taskNumbers: taskNumberData.taskNumbers,
         id:taskNumberData._id});
      } catch (error) {
        console.error("Error fetching task number:", error);
      }
    };
    fetchTaskNumber();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleTaskNumberChange = (e) => {
    setCurrentTaskNumber(e.target.value);
  };

  const handleAddTaskNumber = () => {
    if (currentTaskNumber.trim() !== "") {
      setFormData((prevData) => ({
        ...prevData,
        taskNumbers: [...prevData.taskNumbers, currentTaskNumber.trim()],
      }));
      setCurrentTaskNumber("");
    }
  };

  const handleRemoveTaskNumber = (index) => {
    setFormData((prevData) => ({
      ...prevData,
      taskNumbers: prevData.taskNumbers.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await updateTaskNumber(formData);
      toast.success("Task Number Update Successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate("/settings/task-number");
      }, 3000);
      console.log("Task number updated successfully");
      // Replace with your desired route after update
    } catch (error) {
      console.error("Error updating task number:", error);
      toast.error("Failed to Update Task Number!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  return (
    <div>
      <Card>
        <h2>Edit Task Number</h2>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col>
              <Form.Group controlId="fullName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Name"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="employeeId">
                <Form.Label>Employee Id</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Employee Id"
                  name="employeeId"
                  value={formData.employeeId}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="taskNumbers">
                <Form.Label>Task Numbers</Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Enter Task Number"
                    value={currentTaskNumber}
                    onChange={handleTaskNumberChange}
                  />
                  <Button
                    variant="outline-secondary"
                    onClick={handleAddTaskNumber}
                  >
                    Add
                  </Button>
                </InputGroup>
                <div>
                  {formData.taskNumbers.map((taskNumber, index) => (
                    <Badge key={index} pill bg="secondary" className="me-2">
                      {taskNumber}{" "}
                      <CloseButton
                        onClick={() => handleRemoveTaskNumber(index)}
                      />
                    </Badge>
                  ))}
                </div>
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end mb-4">
            <Button variant="primary" type="submit">
              Update Task Number
            </Button>
          </div>
        </Form>
      </Card>
      {/* Toast Notification Container */}
      <ToastContainer />
    </div>
  );
};

export default EditTaskNumber;
